var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"consent-box"},[_c('span',{class:`consent-box__checkbox ${_vm.value ? 'consent-box__checkbox--checked' : ''}`,on:{"click":_vm.toggle}},[_c('check-icon',{attrs:{"checked":_vm.value}})],1),_c('div',{staticClass:"consent-box__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }